import React, { useState } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log("Subscribed with email:", email);
    setEmail(""); // Clear input after submitting
  };

  // const onSubmitEmail = async (e) => {
  //   e.preventDefault();

  //   if (!isValidEmail(email)) {
  //     swal({
  //       icon: "info",
  //       title: "Please enter a valid Email!",
  //       showConfirmButton: false,
  //       timer: 2000,
  //     });
  //     return;
  //   }
  //   try {
  //     // Check if the email already exists in the "Subscribers" collection
  //     const q = query(subscribersRef, where("email", "==", email));
  //     const querySnapshot = await getDocs(q);

  //     if (!querySnapshot.empty) {
  //       swal({
  //         icon: "info",
  //         title: "Email already subscribed!",
  //         showConfirmButton: false,
  //         timer: 2000,
  //       });
  //       return;
  //     }

  //     await addDoc(subscribersRef, {
  //       // userId: user?.user?.uid,
  //       email: email,
  //     });

  //     swal({
  //       icon: "success",
  //       title: "You have successfully subscribed to Cook-E",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       confirmButtonColor: "#f0481a",
  //     });
  //   } catch (err) {
  //     console.log(err.message);

  //     swal({
  //       icon: "info",
  //       title: err.message,
  //       showConfirmButton: false,
  //       timer: 2000,
  //     });
  //   }
  // };

  return (
    <footer className="bg-[#A67FAA] py-8 px-10">
      <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between px-4 sm:px-0">
        {/* Left side - Newsletter Subscription */}
        <div className="flex flex-col lg:flex-row items-center justify-center px-4">
          <p className="text-white text-lg mb-4 lg:mb-0 -ml-16 md:w-2/4 px-10 md:text-left text-center font-publicSans w-full">
            Follow our Medium newsletter for exciting new dishes and updates!
          </p>
          <form
            onSubmit={handleSubscribe}
            className="flex items-center bg-white rounded-sm  px-3 py-1  shadow-md"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="rounded-full  py-2 border-none font-publicSans focus:outline-none focus:ring-0 w-64 text-gray-800"
              required
              style={{
                outline: "none",
                boxShadow: "none",
                border: "none",
              }}
              onFocus={(e) => (e.target.style.outline = "none")}
            />
            <button
              type="submit"
              className="ml-2 font-publicSans bg-[#A67FAA] text-white rounded-sm px-6 py-2 hover:bg-[#955c9d] transition"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Right side - Social Media Icons */}
        <div className="flex space-x-4 mt-4 lg:mt-0">
          <a href="#" className="text-white hover:text-gray-300">
            <FaFacebookF size={24} />
          </a>
          <a href="#" className="text-white hover:text-gray-300">
            <FaTwitter size={24} />
          </a>
          <a href="#" className="text-white hover:text-gray-300">
            <FaInstagram size={24} />
          </a>
          <a href="#" className="text-white hover:text-gray-300">
            <FaLinkedinIn size={24} />
          </a>
          <a href="#" className="text-white hover:text-gray-300">
            <FaYoutube size={24} />
          </a>
        </div>
      </div>

      {/* Copyright and Legal Links */}
      <div className="border-t border-gray-300 mt-8 pt-4">
        <p className="text-center text-white font-publicSans text-base">
          Copyright &copy; {new Date().getFullYear()} Cook-E | All Rights
          Reserved |{" "}
          <a href="/terms-of-service" className="hover:underline text-white">
            Terms and Conditions
          </a>{" "}
          |{" "}
          <a href="/privacy-policy" className="hover:underline text-white">
            Privacy Policy
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
